import type { LegendaSimuladoProps } from "./types-legenda-simulado";
import { useLegendaSimulado } from "./use-legenda-simulado";
import { LegendaSimuladoView } from "./view-legenda-simulado";

/** Item da legenda, só no Modo Simulação. */
export function LegendaSimulado(props: LegendaSimuladoProps) {
  const vm = useLegendaSimulado(props);

  return <LegendaSimuladoView {...vm} />;
}

export type * from "./types-legenda-simulado";
